module.exports = __webpack_public_path__ + "img/icon-sewing.8d27ee51.gif";